
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index854hq0DU0W6hAW0yFkUYkOY9aVXyrnK4JiXZ6HJAn_0Meta } from "/usr/src/nuxt-app/pages/index.vue?macro=true";
import { default as contactm3gvMLAdFFya1mmzROQVlpzBGzYLm0jMdyDtb_45AQD_45EMeta } from "/usr/src/nuxt-app/pages/contact.vue?macro=true";
import { default as indexUYiJzLF8_450uLUr_aCM0JswVjsFQmpSWxFuZX1Efx1aUMeta } from "/usr/src/nuxt-app/pages/map/index.vue?macro=true";
import { default as indexLU_45XmwnPI0G2Z5H0YAPW3QHOZh_XdS7Rrs_45tRBsQ5sEMeta } from "/usr/src/nuxt-app/pages/login/index.vue?macro=true";
import { default as indexh9W6UL1CqtuYRnBeNd_8JkOERz9vpj2XuJ5fKZHHU2gMeta } from "/usr/src/nuxt-app/pages/stock/index.vue?macro=true";
import { default as indexTgCps4IGQR9fhrUDBuEbZnxx7dvhqJUsfTAVLFs9jikMeta } from "/usr/src/nuxt-app/pages/users/index.vue?macro=true";
import { default as homeFCQcCZOZL_455jKdh_q0u1MV9NivDELkJ8p_45G7PjVEA8kMeta } from "/usr/src/nuxt-app/pages/agencies/home.vue?macro=true";
import { default as indexsf9u58A68fTT_45782SbhOBcrqEAOqjh0adZROjlvemwMMeta } from "/usr/src/nuxt-app/pages/agencies/index.vue?macro=true";
import { default as indexpscE_45y7apFK9HeKbFxJvhpExrttlHTLTYDxbNKOSoiYMeta } from "/usr/src/nuxt-app/pages/annuaire/index.vue?macro=true";
import { default as indexpFOkmLrLX7DcNfJf9SPa8CfD8p_CI5WUtjb8niK3XZsMeta } from "/usr/src/nuxt-app/pages/products/index.vue?macro=true";
import { default as indexRGMUk3KInEpmJSQBWqeyC1s6ToVU_QstOzx_YfPVF00Meta } from "/usr/src/nuxt-app/pages/countries/index.vue?macro=true";
import { default as managmentslIsZkxdGV8k5TmnyW_45kDuoAAwTB7AxjxdoEF_pWu2UMeta } from "/usr/src/nuxt-app/pages/stock/managment.vue?macro=true";
import { default as indexAjwc_3OgGk6ps_45AZZ8oJf05T3HNPEAPH_45_fM80AWjikMeta } from "/usr/src/nuxt-app/pages/controllers/index.vue?macro=true";
import { default as indexLLTrmZFOlU2g5cUX7Pm6PpPlA07h16Oyec_45h6RwnoeoMeta } from "/usr/src/nuxt-app/pages/stat-center/index.vue?macro=true";
import { default as indexo0mz_wLLcEQ9Z0mVaDfAB39tRgU6tUVReo4ILtdjkBIMeta } from "/usr/src/nuxt-app/pages/admin-report/index.vue?macro=true";
import { default as indexNxYx3V5KQnbQd3e1ftEbkjr0zAQM1Ctpi3xgA8KYY_8Meta } from "/usr/src/nuxt-app/pages/notification/index.vue?macro=true";
import { default as distributionyV_45LmCQUx4Cr_33rpnKmx_45VktPvGcdmkRM1cS6AR8_45EMeta } from "/usr/src/nuxt-app/pages/stock/distribution.vue?macro=true";
import { default as indexOd0bOEGT8ZUzmb4dQkjFguR4tdVfnRPjJ23Rx9QsKoQMeta } from "/usr/src/nuxt-app/pages/configuration/index.vue?macro=true";
import { default as index02FVGiBblRRKSJ2PKF5Et46Zibi9098o5KBTugYyPXUMeta } from "/usr/src/nuxt-app/pages/static_upload/index.vue?macro=true";
import { default as indexP2KPRTyrvG74jR4VtAuVBDSl9QJfOMgCwBk0DXMouKQMeta } from "/usr/src/nuxt-app/pages/agencies/teams/index.vue?macro=true";
import { default as indexHx3azcfHdMem09IUDMQnjocRT_45XQ5p15cQW6Lbd_45vNYMeta } from "/usr/src/nuxt-app/pages/agencies/details/index.vue?macro=true";
import { default as indexVpl8Es3YaMn_45xS2XO2XDuEjEmN_mE3iYy9HyMJ6uXWgMeta } from "/usr/src/nuxt-app/pages/agencies/sectors/index.vue?macro=true";
import { default as indexVhwAdZEsHFTnCAgM9fJfYa99Eq_45etC0tFmi_69EgUBUMeta } from "/usr/src/nuxt-app/pages/marking_operator/index.vue?macro=true";
import { default as indexCMMiYkRcwsW8o_459Oht53Jy8EbqdbdptzEvJ425MA0_45AMeta } from "/usr/src/nuxt-app/pages/products/details/index.vue?macro=true";
import { default as indextm3XBA9hLDWOc83rxmnQkX8C9JBMMZsuhNPMi7X2QuIMeta } from "/usr/src/nuxt-app/pages/agencies/products/index.vue?macro=true";
import { default as indexrW33ft0GAS_qDtCyCW6tdy_cdPwkN2Ee1x_45PU0ZfWN4Meta } from "/usr/src/nuxt-app/pages/controllers/[uid]/index.vue?macro=true";
import { default as indexDcKHFKPl6Ozl2nM0hUPmUTTOJdGj6ee4D6G3a_45nknJwMeta } from "/usr/src/nuxt-app/pages/countries/details/index.vue?macro=true";
import { default as indexL2ocUMVCjzqs7PLavTFekqqR88cxRE2ByAJXEtGZraEMeta } from "/usr/src/nuxt-app/pages/agencies/delegates/index.vue?macro=true";
import { default as indexgFda8y7imm_Jg30e6wDLhRsJDH08_45Lot68RAc2dT4ugMeta } from "/usr/src/nuxt-app/pages/annuaire/prospects/index.vue?macro=true";
import { default as indexjn5taw5h_wj2vyXb48e5KAmDR4_45jYKr6TvUDnhpfb7AMeta } from "/usr/src/nuxt-app/pages/users/user_details/index.vue?macro=true";
import { default as indexBPVO0upkhYq_45e0s1MmK0p0mnXuLQ76gviByJtBlJ6YQMeta } from "/usr/src/nuxt-app/pages/print-qrcode/[name]/index.vue?macro=true";
import { default as agency_45distribution_LxahO3Q9ESN0AwOU4cSb0Z9rhMc0A9RoRXmoqq568oMeta } from "/usr/src/nuxt-app/pages/stock/agency-distribution.vue?macro=true";
import { default as indexfc_45VEXuy_BZuCa6WOlplOaUXpF1rd_5yz_45VzD04tWqcMeta } from "/usr/src/nuxt-app/pages/controller_reports_x/index.vue?macro=true";
import { default as indexwUaXw8Qtek2loW7mQn9Wp_45J6TtOeeGB9ai2PunND9vcMeta } from "/usr/src/nuxt-app/pages/marking_operator/map/index.vue?macro=true";
import { default as indexHEYxkO4KBZMw9m1L2d128ko77dNBbhHAxsk60qFgWaMMeta } from "/usr/src/nuxt-app/pages/controllers-statistics/index.vue?macro=true";
import { default as indexmcCM2uBYpM8bjx4Up2Cb77MRd0w6rjO4Kf_45g6kPl5YgMeta } from "/usr/src/nuxt-app/pages/annuaire/health-centers/index.vue?macro=true";
import { default as index_45GunfCgR46CEBA7QpvDPfLhjjLSSpqEM_458BEUENa5BcMeta } from "/usr/src/nuxt-app/pages/controllers-done-reports/index.vue?macro=true";
import { default as _91id_93yta6gdwE6WdXu3suoLEk_OsfwIl3064M3O_45XM7U_QjcMeta } from "/usr/src/nuxt-app/pages/marking_operator/sessions/[id].vue?macro=true";
import { default as indextbDvrS_45yHik3v4czVYVvmMFHem1xe6gFR_45eBo87kpH4Meta } from "/usr/src/nuxt-app/pages/agencies/rejected-reports/index.vue?macro=true";
import { default as indexyAcR7gyVwS7Ipi_TTtudDBVsv_45RlNqFVDnmiTJHCC90Meta } from "/usr/src/nuxt-app/pages/marking_operator/sessions/index.vue?macro=true";
import { default as indexr_rC9JzZTsg2nVWZbvzaNQWb49dQSJv7CGJueenaGlkMeta } from "/usr/src/nuxt-app/pages/stat-center/stat-products/index.vue?macro=true";
import { default as indexREfH2Fu_8OmVwa_6FaAUqE_iGRDM_Wvh9VNqU1fCiGIMeta } from "/usr/src/nuxt-app/pages/admin-report/detail/[detail]/index.vue?macro=true";
import { default as index7p9OnUBNgbjUWCsQF5cKyQtu5H47rQqtD_SBP2EgUmkMeta } from "/usr/src/nuxt-app/pages/marking_operator/marker_list/index.vue?macro=true";
import { default as indexEjvSFfnU20mbzhk_muQl_yc1pHu7wcFHNmDxdZXmLboMeta } from "/usr/src/nuxt-app/pages/marking_operator/marker_stat/index.vue?macro=true";
import { default as indexBDtv0rfa8_45e55GhhvbeP6BXCrX3xOEBQQF7TiKsk6UcMeta } from "/usr/src/nuxt-app/pages/stat-center/health-frequency/index.vue?macro=true";
import { default as index7_bA49WmaqSZ_450uGUS_PFc0Va_45BAXqBjxrw3ommgA54Meta } from "/usr/src/nuxt-app/pages/stat-center/product-analizer/index.vue?macro=true";
import { default as indexOCY7JH1mzj2Mp0Iax6avfSn5cgb1jyx1cqO456hV0J8Meta } from "/usr/src/nuxt-app/pages/agencies/appointments-reports/index.vue?macro=true";
import { default as index_HIF5UxyBwA_453g5fvjxvSLM42KxJV_45fmOrrEuhy1G3gMeta } from "/usr/src/nuxt-app/pages/annuaire/details/[prospect_id]/index.vue?macro=true";
import { default as indexkahiVO_45p6_LasMOuwPGBKpMjSoHzboiSVLNLwUmoKFMMeta } from "/usr/src/nuxt-app/pages/controllers/controller-members/index.vue?macro=true";
import { default as index7MyK0F9l__JxMIfBKBH_450sgtdV6jJ1FwB7_S_MjLsJgMeta } from "/usr/src/nuxt-app/pages/stat-center/delegate-activities/index.vue?macro=true";
import { default as indexhPcVM8sLhA1IKXEXtdtMlZVM2_45VQl0wyEKrqg7MgZcoMeta } from "/usr/src/nuxt-app/pages/marking_operator/marker_list/[uid]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: { ...(index854hq0DU0W6hAW0yFkUYkOY9aVXyrnK4JiXZ6HJAn_0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: { ...(contactm3gvMLAdFFya1mmzROQVlpzBGzYLm0jMdyDtb_45AQD_45EMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/contact.vue")
  },
  {
    name: "map",
    path: "/map",
    meta: { ...(indexUYiJzLF8_450uLUr_aCM0JswVjsFQmpSWxFuZX1Efx1aUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/map/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexLU_45XmwnPI0G2Z5H0YAPW3QHOZh_XdS7Rrs_45tRBsQ5sEMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/login/index.vue")
  },
  {
    name: "stock",
    path: "/stock",
    component: () => import("/usr/src/nuxt-app/pages/stock/index.vue")
  },
  {
    name: "users",
    path: "/users",
    meta: { ...(indexTgCps4IGQR9fhrUDBuEbZnxx7dvhqJUsfTAVLFs9jikMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/users/index.vue")
  },
  {
    name: "agencies-home",
    path: "/agencies/home",
    meta: { ...(homeFCQcCZOZL_455jKdh_q0u1MV9NivDELkJ8p_45G7PjVEA8kMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/agencies/home.vue")
  },
  {
    name: "agencies",
    path: "/agencies",
    meta: { ...(indexsf9u58A68fTT_45782SbhOBcrqEAOqjh0adZROjlvemwMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/agencies/index.vue")
  },
  {
    name: "annuaire",
    path: "/annuaire",
    meta: { ...(indexpscE_45y7apFK9HeKbFxJvhpExrttlHTLTYDxbNKOSoiYMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/annuaire/index.vue")
  },
  {
    name: "products",
    path: "/products",
    component: () => import("/usr/src/nuxt-app/pages/products/index.vue")
  },
  {
    name: "countries",
    path: "/countries",
    component: () => import("/usr/src/nuxt-app/pages/countries/index.vue")
  },
  {
    name: "stock-managment",
    path: "/stock/managment",
    meta: { ...(managmentslIsZkxdGV8k5TmnyW_45kDuoAAwTB7AxjxdoEF_pWu2UMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/stock/managment.vue")
  },
  {
    name: "controllers",
    path: "/controllers",
    meta: { ...(indexAjwc_3OgGk6ps_45AZZ8oJf05T3HNPEAPH_45_fM80AWjikMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/controllers/index.vue")
  },
  {
    name: "stat-center",
    path: "/stat-center",
    meta: { ...(indexLLTrmZFOlU2g5cUX7Pm6PpPlA07h16Oyec_45h6RwnoeoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/stat-center/index.vue")
  },
  {
    name: "admin-report",
    path: "/admin-report",
    meta: { ...(indexo0mz_wLLcEQ9Z0mVaDfAB39tRgU6tUVReo4ILtdjkBIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/admin-report/index.vue")
  },
  {
    name: "notification",
    path: "/notification",
    meta: { ...(indexNxYx3V5KQnbQd3e1ftEbkjr0zAQM1Ctpi3xgA8KYY_8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/notification/index.vue")
  },
  {
    name: "stock-distribution",
    path: "/stock/distribution",
    meta: { ...(distributionyV_45LmCQUx4Cr_33rpnKmx_45VktPvGcdmkRM1cS6AR8_45EMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/stock/distribution.vue")
  },
  {
    name: "configuration",
    path: "/configuration",
    component: () => import("/usr/src/nuxt-app/pages/configuration/index.vue")
  },
  {
    name: "static_upload",
    path: "/static_upload",
    meta: { ...(index02FVGiBblRRKSJ2PKF5Et46Zibi9098o5KBTugYyPXUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/static_upload/index.vue")
  },
  {
    name: "agencies-teams",
    path: "/agencies/teams",
    meta: { ...(indexP2KPRTyrvG74jR4VtAuVBDSl9QJfOMgCwBk0DXMouKQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/agencies/teams/index.vue")
  },
  {
    name: "agencies-details",
    path: "/agencies/details",
    meta: { ...(indexHx3azcfHdMem09IUDMQnjocRT_45XQ5p15cQW6Lbd_45vNYMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/agencies/details/index.vue")
  },
  {
    name: "agencies-sectors",
    path: "/agencies/sectors",
    meta: { ...(indexVpl8Es3YaMn_45xS2XO2XDuEjEmN_mE3iYy9HyMJ6uXWgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/agencies/sectors/index.vue")
  },
  {
    name: "marking_operator",
    path: "/marking_operator",
    meta: { ...(indexVhwAdZEsHFTnCAgM9fJfYa99Eq_45etC0tFmi_69EgUBUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/marking_operator/index.vue")
  },
  {
    name: "products-details",
    path: "/products/details",
    meta: { ...(indexCMMiYkRcwsW8o_459Oht53Jy8EbqdbdptzEvJ425MA0_45AMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/products/details/index.vue")
  },
  {
    name: "agencies-products",
    path: "/agencies/products",
    meta: { ...(indextm3XBA9hLDWOc83rxmnQkX8C9JBMMZsuhNPMi7X2QuIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/agencies/products/index.vue")
  },
  {
    name: "controllers-uid",
    path: "/controllers/:uid()",
    meta: { ...(indexrW33ft0GAS_qDtCyCW6tdy_cdPwkN2Ee1x_45PU0ZfWN4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/controllers/[uid]/index.vue")
  },
  {
    name: "countries-details",
    path: "/countries/details",
    meta: { ...(indexDcKHFKPl6Ozl2nM0hUPmUTTOJdGj6ee4D6G3a_45nknJwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/countries/details/index.vue")
  },
  {
    name: "agencies-delegates",
    path: "/agencies/delegates",
    meta: { ...(indexL2ocUMVCjzqs7PLavTFekqqR88cxRE2ByAJXEtGZraEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/agencies/delegates/index.vue")
  },
  {
    name: "annuaire-prospects",
    path: "/annuaire/prospects",
    meta: { ...(indexgFda8y7imm_Jg30e6wDLhRsJDH08_45Lot68RAc2dT4ugMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/annuaire/prospects/index.vue")
  },
  {
    name: "users-user_details",
    path: "/users/user_details",
    meta: { ...(indexjn5taw5h_wj2vyXb48e5KAmDR4_45jYKr6TvUDnhpfb7AMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/users/user_details/index.vue")
  },
  {
    name: "print-qrcode-name",
    path: "/print-qrcode/:name()",
    meta: indexBPVO0upkhYq_45e0s1MmK0p0mnXuLQ76gviByJtBlJ6YQMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/print-qrcode/[name]/index.vue")
  },
  {
    name: "stock-agency-distribution",
    path: "/stock/agency-distribution",
    meta: { ...(agency_45distribution_LxahO3Q9ESN0AwOU4cSb0Z9rhMc0A9RoRXmoqq568oMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/stock/agency-distribution.vue")
  },
  {
    name: "controller_reports_x",
    path: "/controller_reports_x",
    meta: { ...(indexfc_45VEXuy_BZuCa6WOlplOaUXpF1rd_5yz_45VzD04tWqcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/controller_reports_x/index.vue")
  },
  {
    name: "marking_operator-map",
    path: "/marking_operator/map",
    meta: { ...(indexwUaXw8Qtek2loW7mQn9Wp_45J6TtOeeGB9ai2PunND9vcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/marking_operator/map/index.vue")
  },
  {
    name: "controllers-statistics",
    path: "/controllers-statistics",
    meta: { ...(indexHEYxkO4KBZMw9m1L2d128ko77dNBbhHAxsk60qFgWaMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/controllers-statistics/index.vue")
  },
  {
    name: "annuaire-health-centers",
    path: "/annuaire/health-centers",
    meta: { ...(indexmcCM2uBYpM8bjx4Up2Cb77MRd0w6rjO4Kf_45g6kPl5YgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/annuaire/health-centers/index.vue")
  },
  {
    name: "controllers-done-reports",
    path: "/controllers-done-reports",
    meta: { ...(index_45GunfCgR46CEBA7QpvDPfLhjjLSSpqEM_458BEUENa5BcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/controllers-done-reports/index.vue")
  },
  {
    name: "marking_operator-sessions-id",
    path: "/marking_operator/sessions/:id()",
    meta: { ...(_91id_93yta6gdwE6WdXu3suoLEk_OsfwIl3064M3O_45XM7U_QjcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/marking_operator/sessions/[id].vue")
  },
  {
    name: "agencies-rejected-reports",
    path: "/agencies/rejected-reports",
    meta: { ...(indextbDvrS_45yHik3v4czVYVvmMFHem1xe6gFR_45eBo87kpH4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/agencies/rejected-reports/index.vue")
  },
  {
    name: "marking_operator-sessions",
    path: "/marking_operator/sessions",
    meta: { ...(indexyAcR7gyVwS7Ipi_TTtudDBVsv_45RlNqFVDnmiTJHCC90Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/marking_operator/sessions/index.vue")
  },
  {
    name: "stat-center-stat-products",
    path: "/stat-center/stat-products",
    meta: { ...(indexr_rC9JzZTsg2nVWZbvzaNQWb49dQSJv7CGJueenaGlkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/stat-center/stat-products/index.vue")
  },
  {
    name: "admin-report-detail-detail",
    path: "/admin-report/detail/:detail()",
    component: () => import("/usr/src/nuxt-app/pages/admin-report/detail/[detail]/index.vue")
  },
  {
    name: "marking_operator-marker_list",
    path: "/marking_operator/marker_list",
    meta: { ...(index7p9OnUBNgbjUWCsQF5cKyQtu5H47rQqtD_SBP2EgUmkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/marking_operator/marker_list/index.vue")
  },
  {
    name: "marking_operator-marker_stat",
    path: "/marking_operator/marker_stat",
    meta: { ...(indexEjvSFfnU20mbzhk_muQl_yc1pHu7wcFHNmDxdZXmLboMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/marking_operator/marker_stat/index.vue")
  },
  {
    name: "stat-center-health-frequency",
    path: "/stat-center/health-frequency",
    meta: { ...(indexBDtv0rfa8_45e55GhhvbeP6BXCrX3xOEBQQF7TiKsk6UcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/stat-center/health-frequency/index.vue")
  },
  {
    name: "stat-center-product-analizer",
    path: "/stat-center/product-analizer",
    meta: { ...(index7_bA49WmaqSZ_450uGUS_PFc0Va_45BAXqBjxrw3ommgA54Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/stat-center/product-analizer/index.vue")
  },
  {
    name: "agencies-appointments-reports",
    path: "/agencies/appointments-reports",
    meta: { ...(indexOCY7JH1mzj2Mp0Iax6avfSn5cgb1jyx1cqO456hV0J8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/agencies/appointments-reports/index.vue")
  },
  {
    name: "annuaire-details-prospect_id",
    path: "/annuaire/details/:prospect_id()",
    meta: { ...(index_HIF5UxyBwA_453g5fvjxvSLM42KxJV_45fmOrrEuhy1G3gMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/annuaire/details/[prospect_id]/index.vue")
  },
  {
    name: "controllers-controller-members",
    path: "/controllers/controller-members",
    meta: { ...(indexkahiVO_45p6_LasMOuwPGBKpMjSoHzboiSVLNLwUmoKFMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/controllers/controller-members/index.vue")
  },
  {
    name: "stat-center-delegate-activities",
    path: "/stat-center/delegate-activities",
    meta: { ...(index7MyK0F9l__JxMIfBKBH_450sgtdV6jJ1FwB7_S_MjLsJgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/stat-center/delegate-activities/index.vue")
  },
  {
    name: "marking_operator-marker_list-uid",
    path: "/marking_operator/marker_list/:uid()",
    meta: { ...(indexhPcVM8sLhA1IKXEXtdtMlZVM2_45VQl0wyEKrqg7MgZcoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/nuxt-app/pages/marking_operator/marker_list/[uid]/index.vue")
  }
]